import {
	BotLayerParams,
	BotType,
	GetBotLinkProps,
	GetMarketAlgosLinkProps,
	GetPartyLinkProps,
	GetMarketLinkProps,
} from "./types";

export const getBotRoutePath = ({ botType }: BotLayerParams) => `${botType}/:uuid/`;

export const getBotLink = <T extends BotType>({
	partyUUID,
	botType,
	uuid,
	botTab,
}: GetBotLinkProps<T>) => `/party/${partyUUID}/${botType}/${uuid}${botTab ? `/${botTab}` : ""}`;

export const getPartySectionLink = ({ partyUUID, partySection }: GetPartyLinkProps) =>
	`/party/${partyUUID}/${partySection}`;

export const getMarketSectionLink = ({
	partyUUID,
	marketUUID,
	marketSection,
}: GetMarketLinkProps) => `/party/${partyUUID}/markets/${marketUUID}/${marketSection}`;

export const getMarketAlgosSectionLink = ({
	partyUUID,
	marketUUID,
	marketAlgosSection,
}: GetMarketAlgosLinkProps) =>
	`/party/${partyUUID}/markets/${marketUUID}/algos/${marketAlgosSection}`;
